import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clipboard-icon',
  templateUrl: './clipboard-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClipboardIconComponent {}
